/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { Expertise } from './platformapi.schemas';

import getExpertisesMutator from '../custom-axios-instance';

/**
 * Retrieves a list of expertises
 * @summary Get Expertises
 */
export const getExpertises = (signal?: AbortSignal) => {
  return getExpertisesMutator<Expertise[]>({
    url: `${import.meta.env['VITE_API_HOST']}/expertises/expertises`,
    method: 'GET',
    signal,
  });
};

export const getGetExpertisesQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/expertises/expertises`] as const;
};

export const getGetExpertisesQueryOptions = <
  TData = Awaited<ReturnType<typeof getExpertises>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertises>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetExpertisesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getExpertises>>> = ({ signal }) =>
    getExpertises(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getExpertises>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetExpertisesQueryResult = NonNullable<Awaited<ReturnType<typeof getExpertises>>>;
export type GetExpertisesQueryError = void;

export function useGetExpertises<TData = Awaited<ReturnType<typeof getExpertises>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertises>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertises>>,
          TError,
          Awaited<ReturnType<typeof getExpertises>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetExpertises<TData = Awaited<ReturnType<typeof getExpertises>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertises>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExpertises>>,
          TError,
          Awaited<ReturnType<typeof getExpertises>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetExpertises<TData = Awaited<ReturnType<typeof getExpertises>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertises>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Expertises
 */

export function useGetExpertises<TData = Awaited<ReturnType<typeof getExpertises>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getExpertises>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetExpertisesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
